import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Datagrid from "../../components/Datagrid/Datagrid";
import { useSite } from "../../context/siteContext";
import customHttp from "../../services/customHTTP";
import { Alert, Box, CircularProgress, Link } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { useCart } from "../../context/cartContext";
import { ASSETS_BASE_URL } from "../../config";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeleteIcon from "@mui/icons-material/Delete";

const Requests = () => {
	const [savedForlater, setSavedForlater] = useState([]);
	const [loading, setloading] = useState(true);
	const [selectedSFLRows, setSelectedSFLRows] = useState([]);
	const [error, setError] = useState("");
	const { selectedSite, selectedSiteCurrency, currencySymbol } = useSite();
	const navigate = useNavigate();
	const { user } = useAuth();
	const { addMultipleToCart } = useCart();

	useEffect(() => {
		const fetchReqList = async () => {
			const req_body = {
				site_number: selectedSite,
				user_id: user.user_id,
			};

			try {
				const response = await customHttp.post("/saved_for_later/bysiteid", req_body);
				console.log(response);
				if (response.data.success) {
					console.log(response.data.data);
					const products = response.data.data;
					const purchasableProducts = products
						.filter((product) => product.purchasable === 1)
						.map((product) => {
							const key = `price_${selectedSiteCurrency}`;
							const currencyPrice = product[key];
							const finalPrice = product.purchasable ? currencyPrice : 0;
							return {
								product_id: product.product_id,
								product_name: product.product_name,
								product_number: product.product_number,
								machine_id: product.machine_id,
								machine_number: product.machine_number,
								product_price: finalPrice,
								added_by: `${product.user_first_name || ""} ${product.user_last_name || ""}`,
							};
						});
					console.log(purchasableProducts);
					setSavedForlater(purchasableProducts);
					setloading(false);
				}
			} catch (error) {
				console.error("Error fetching Saved for Later Products:", error);
				setError(error);
			}
		};
		if (selectedSite !== "") fetchReqList();
	}, [selectedSite]);

	const handleRowSelect = (rows) => {
		setSelectedSFLRows(rows);
	};

	const handleAddtoCart = async () => {
		// Check if any rows are selected
		if (selectedSFLRows.length === 0) {
			// Show alert if no users are selected
			Swal.fire({
				icon: "warning",
				title: "No Part(s) Selected",
				text: "Please select products to add to cart.",
			});
			return;
		}
		console.log(selectedSFLRows);
		const purchasableProducts = [];
		selectedSFLRows.forEach((productId) => {
			const product = savedForlater.find((product) => product.product_id === productId);
			console.log(product);
			if (product) {
				const productEntry = {
					ProductID: product.product_id,
					Quantity: 1,
					Site: selectedSite,
				};
				purchasableProducts.push(productEntry);
			}
		});
		console.log(purchasableProducts);
		if (purchasableProducts.length > 0) {
			await addMultipleToCart(purchasableProducts);
			Swal.fire({
				title: "Success!",
				text: "Part(s) Added to Cart",
				icon: "success",
			});
			// Remove the added products from the saved for later list
			const remainingProducts = savedForlater.filter((product) => !selectedSFLRows.includes(product.product_id));
			setSavedForlater(remainingProducts);

			// Remove the added products from the saved_for_later table
			try {
				await customHttp.post("/saved_for_later/remove", {
					product_ids: selectedSFLRows,
					user_id: user.user_id,
					site_number: selectedSite,
				});
			} catch (error) {
				console.error("Error removing part(s) from saved for later:", error);
			}
		}
		// Confirm deletion if users are selected
	};

	const handleRemoveFromSavedForLater = async () => {
		// Check if any rows are selected
		if (selectedSFLRows.length === 0) {
			// Show alert if no products are selected
			Swal.fire({
				icon: "warning",
				title: "No Part(s) Selected",
				text: "Please select Part(s) to remove.",
			});
			return;
		}
		console.log(selectedSFLRows);

		try {
			// Remove the selected products from the saved_for_later table
			await customHttp.post("/saved_for_later/remove", {
				product_ids: selectedSFLRows,
				user_id: user.user_id,
				site_number: selectedSite,
			});

			// Remove the selected products from the saved for later list
			const remainingProducts = savedForlater.filter((product) => !selectedSFLRows.includes(product.product_id));
			setSavedForlater(remainingProducts);

			Swal.fire({
				title: "Success!",
				text: "Part(s) Removed from Saved for Later",
				icon: "success",
			});
		} catch (error) {
			console.error("Error removing part(s) from saved for later:", error);
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "Failed to remove part(s) from Saved for Later.",
			});
		}
	};

	const customButtons = [
		{
			label: "Move To Cart",
			onClick: () => {
				handleAddtoCart();
			},
			icon: <ShoppingCartIcon />,
		},
		{
			label: "Remove",
			onClick: () => {
				handleRemoveFromSavedForLater();
			},
			icon: <DeleteIcon />,
		},
	];

	const columns = [
		{
			field: "product_name",
			headerName: "Part Name",
			flex: 1,
			renderCell: (params) => {
				const defaultImage = `${ASSETS_BASE_URL}/stock.png`;

				const handleError = (e) => {
					e.target.onerror = null; // Prevent infinite loop
					e.target.src = defaultImage; // Fallback to default image
				};

				const src = `${ASSETS_BASE_URL}/ProductImages/TMB/${params.row.product_number}.png`;

				return (
					<div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-start" }}>
						<img
							src={src}
							alt={params.row.product_name}
							onError={handleError}
							style={{
								width: "40px",
								height: "40px",
								objectFit: "cover",
								borderRadius: "4px",
							}}
						/>
						<div>
							<Link
								sx={{ cursor: "pointer" }}
								variant="body2"
								onClick={() => {
									navigate(`/machines/${params.row.machine_id}/${params.row.product_id}`);
								}}>
								{params.row.product_name}
							</Link>
						</div>
					</div>
				);
			},
		},
		{ field: "product_number", headerName: "Part #", width: 150 },
		{ field: "machine_number", headerName: "Machine" },
		{
			field: "product_price",
			headerName: "Price",
			width: 120,
			renderCell: (params) => {
				return (
					<div>
						{currencySymbol}
						{params.row.product_price}
					</div>
				);
			},
		},
		{
			field: "added_by",
			headerName: "Added By",
			renderCell: (params) => {
				return params.row.added_by === " " ? "N/A" : params.row.added_by;
			},
		},
	];

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	if (error) {
		return (
			<Alert severity="error" className="error-alert">
				{error}
			</Alert>
		);
	}

	return (
		<div className="order-history-container">
			<PageTitle title="Saved For Later" />

			{savedForlater.length === 0 && !loading ? (
				<Alert severity="info" className="error-alert" sx={{ marginTop: "10px" }}>
					No Products in Saved for Later
				</Alert>
			) : (
				<Datagrid
					key="product_id"
					data={savedForlater}
					columns={columns}
					rowClick={false}
					pageSize={5}
					showSearchBar={true}
					checkboxSelection={true}
					customButtons={customButtons}
					onSelect={handleRowSelect}
					rowIdField="product_id"
					sortBy={[{ field: "product_name", sort: "asc" }]}
				/>
			)}
		</div>
	);
};

export default Requests;
